import React, { useEffect, useState } from "react";
import { Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { AddUpdate, decrypt } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import {
  get_Dropdown_Category,
  get_Expense_Details,
  get_Insert_ExpenseDetails,
  get_Single_Expense_Details,
  get_Update_ExpenseDetails,
} from "../../../store/actions/CommanAction";
import Loader from "../Loader/Loader";

const ExpenseDetails = () => {
  const dispatch = useDispatch();
  const ExpenseCategory = useSelector(
    (state) => state.feedBackReducer.ExpenseDetails
  );
  const decryptedExpenseList = ExpenseCategory?.map((item) => {
    let decryptedCategory = item.Category
      ? decrypt(item.Category)
      : item.Category;

    if (decryptedCategory) {
      decryptedCategory = decryptedCategory.replace(/^"|"$/g, "");
      decryptedCategory = decryptedCategory.replace(/\\/g, "");
    }

    return {
      ...item,
      Category: decryptedCategory,
    };
  });

  useEffect(() => {
    dispatch(get_Dropdown_Category());
  }, [dispatch]);

  const SingleExpenseCategory = useSelector(
    (state) => state.feedBackReducer.SingleExpenseDetails
  );

  const EncrptedDropdownCategory = useSelector(
    (state) => state.feedBackReducer.GetDropdownCategory
  );

  const DropdownCategory = EncrptedDropdownCategory.map((item) => {
    return {
      ...item,
      Category: item.Category?.replace(/["\\]/g, ""),
    };
  });

  const customerID = Number(sessionStorage.getItem("ID"));

  const [IsActive, setIsActive] = useState(true);
  const [postModal, setPostModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [EditValue, setEditValue] = useState("");
  const [ExpenseCategoryID, setExpenseCategoryID] = useState("");
  const [loading, setloading] = useState(false);

  const [addFormData, setaddFormData] = useState({
    Category: "",
    Amount: "",
    Date: "",
    Nextrenewedate: "",
    CreatedByUser: "1",
    IsActive: "1",
  });

  const Reset = () => {
    setaddFormData({
      ...addFormData,
      Category: "",
      Amount: "",
      Date: "",
      Nextrenewedate: "",
    });
  };

  useEffect(() => {
    dispatch(get_Expense_Details(IsActive, setloading));
  }, [dispatch]);

  useEffect(() => {
    if (SingleExpenseCategory) {
      setEditValue(SingleExpenseCategory);
    }
  }, [SingleExpenseCategory]);

  useEffect(() => {
    if (IsActive) {
      dispatch(get_Expense_Details("1", setloading));
    } else {
      dispatch(get_Expense_Details("0", setloading));
    }
  }, [IsActive, IsActive]);

  useEffect(() => {
    if (EditValue && EditValue.length > 0) {

      const formatToDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      };

      setaddFormData({
        ...addFormData,
        ExpenseCategoryID: ExpenseCategoryID,
        Category: EditValue[0]?.ExpenseID,
        Amount: EditValue[0]?.Amount,
        Date: formatToDate(EditValue[0]?.CurrentDate),
        Nextrenewedate: formatToDate(EditValue[0]?.RenewDate),
      });
    }
  }, [EditValue]);

  const handleAddFormSubmit = async (event) => {
    event.preventDefault();
    const newCustomerStory = {
      ExpenseID: addFormData.Category,
      IsActive: addFormData.IsActive,
      Amount: addFormData.Amount,
      CurrentDate: addFormData.Date,
      RenewDate: addFormData.Nextrenewedate,
      CreatedByUser: customerID,
    };


    dispatch(get_Insert_ExpenseDetails(newCustomerStory));
    setPostModal(false);
    dispatch(get_Expense_Details(IsActive, setloading));
    swal("Good job!", "Successfully Added", "success");
    Reset();
    setaddFormData({ Category: "" });
  };

  const UpdateSlider = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";
    if (addFormData.Category === "") {
      error = true;
      errorMsg = "Please fill Skill.";
    }
    if (!error) {
      dispatch(
        get_Update_ExpenseDetails(
          addFormData.Category,
          addFormData.IsActive,
          addFormData.Amount,
          addFormData.Date,
          addFormData.Nextrenewedate,
          customerID,
          ExpenseCategoryID
        )
      );
      setEditModal(false);
      dispatch(get_Expense_Details(IsActive, setloading))
      swal("Good job!", "Successfully update", "success");
      Reset();
      setaddFormData({ Category: "" });
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  const handleAddFormChange = (e) => {

    setaddFormData({ ...addFormData, [e.target.name]: e.target.value });
  };

  const handleEditClick = (row) => {
    dispatch(get_Single_Expense_Details(row?.ExpensedetailsID));
    setExpenseCategoryID(row?.ExpensedetailsID);
    setEditModal(true);
  };

  const columns = [
    {
      name: "Category",
      selector: (row) => row.Category,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.Amount,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row.CurrentDate,
      sortable: true,
    },
    {
      name: "Next Renew Date",
      selector: (row) => row.RenewDate,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <div style={{ position: "absolute", top: 4, right: 50 }}>
          <Dropdown>
            <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                  stroke="#342E59"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Dropdown.Toggle>
            <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
              <Dropdown.Item onClick={() => handleEditClick(row)}>
                Edit
              </Dropdown.Item>
              <Dropdown.Item
                className={row.IsActive ? "text-danger" : "text-success"}
                onClick={() => {
                  handleToggleStatusClick(row.ExpensedetailsID, true, "0");
                }}
              >
                Inactive
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      ),
    },
  ];

  const columns1 = [
    {
      name: "Category",
      selector: (row) => row.Category,
      sortable: true,
    },
    {
      name: "Amount",
      selector: (row) => row.Amount,
      sortable: true,
    },
    {
      name: "Date",
      selector: (row) => row.CurrentDate,
      sortable: true,
    },
    {
      name: "Next Renew Date",
      selector: (row) => row.RenewDate,
      sortable: true,
    },
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 0 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <>
          <div style={{ position: "absolute", top: 4, right: 5 }}>
            <Dropdown>
              <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
                <Dropdown.Item
                  className={row.IsActive ? "text-danger" : "text-success"}
                  onClick={() => {
                    handleToggleStatusClick(row.ExpensedetailsID, false, "1");
                  }}
                >
                  Active
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
  ];

  const handleToggleStatusClick = async (
    ExpenseCategoryID,
    currentStatus,
    isActiveValue
  ) => {
    const postData = {
      ExpensedetailsID: ExpenseCategoryID,
      DeleteByUser: customerID,
      IsActive: isActiveValue,
    };
    await AddUpdate("Expensedetails/Delete_Expensedetails", postData);
    dispatch(get_Expense_Details(currentStatus ? "1" : "0", setloading));
    swal(
      "Good job!",
      `Successfully ${isActiveValue === "1" ? "Active" : "Inactive"}`,
      "success"
    );
  };

  return (
    <>
      <Tab.Container defaultActiveKey="All">
        <div className="main_card mb-1">
          <h2 style={{ color: '#f7931e', fontWeight: 700 }}>Expense Details</h2>

          <div className="mt-2 d-flex justify-content-between align-items-center flex-wrap ">
            <div className="card-action coin-tabs">
              <Nav as="ul" className="nav nav-tabs" role="tablist">
                <Nav.Item as="li" className="nav-item">
                  <Nav.Link
                    className="nav-link"
                    eventKey="All"
                    onClick={(currentStatus) => {
                      setIsActive(true);
                    }}
                  >
                    Active
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item as="li" className="nav-item">
                  <Nav.Link
                    className="nav-link"
                    eventKey="Inactive"
                    onClick={(currentStatus) => {
                      setIsActive(false);
                    }}
                  >
                    Inactive
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            <Link
              to={"#"}
              className="btn btn-primary font-w600 "
              onClick={() => {
                setPostModal(true);
                Reset();
              }}
            >
              + New Expense Details
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="">
              <div className=" p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    <div className="mb-sm-3 d-flex flex-wrap align-items-center text-head">
                      <Modal
                        className="modal fade"
                        show={postModal}
                        onHide={() => setPostModal(false)}
                        backdrop="static"
                      >
                        <form>
                          <div className="modal-header">
                            <h4 className="modal-title fs-20">
                              Add Expense Details
                            </h4>
                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => setPostModal(false)}
                              data-dismiss="modal"
                            ></button>
                          </div>
                          <div className="modal-body p-3">
                            <i
                              className="flaticon-cancel-12 close"
                              data-dismiss="modal"
                            ></i>
                            <div className="add-contact-box">
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div style={{ display: "flex", alignItems: "center", }}>
                                    <label htmlFor="" >Category</label>
                                    <span className="text-danger star-error" style={{ marginTop: "-5px" }}>*</span>
                                  </div>
                                  <select
                                    name="Category"
                                    value={addFormData.Category || ""}
                                    onChange={handleAddFormChange}
                                  >
                                    <option value="" disabled>
                                      Select a category
                                    </option>
                                    {DropdownCategory?.map((category, index) => (
                                      <option
                                        key={index}
                                        value={category.ExpenseCategoryID}
                                      >
                                        {category.Category}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>

                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div style={{ display: "flex", alignItems: "center", }}>
                                    <label htmlFor="">Expense Amount</label>
                                    <span className="text-danger star-error" style={{ marginTop: "-5px" }}>
                                      *
                                    </span>
                                  </div>
                                  <input
                                    type="number"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="Amount"
                                    required="required"
                                    value={addFormData?.Amount}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>

                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div style={{ display: "flex", alignItems: "center", }}>
                                    <label htmlFor=""> Date</label>
                                    <span className="text-danger star-error" style={{ marginTop: "-5px" }}>
                                      *
                                    </span>
                                  </div>
                                  <input
                                    type="date"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="Date"
                                    required="required"
                                    value={addFormData?.Date}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                              <div className="add-contact-content">
                                <div className="form-group">
                                  <div style={{ display: "flex", alignItems: "center", }}>
                                    <label htmlFor=""> Next Renew Date</label>
                                    <span className="text-danger star-error">
                                      *
                                    </span>
                                  </div>

                                  <input
                                    type="date"
                                    // className="form-control"
                                    autoComplete="off"
                                    name="Nextrenewedate"
                                    required="required"
                                    value={addFormData?.Nextrenewedate}
                                    onChange={handleAddFormChange}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="submit"
                              className="btn btn-primary"
                              onClick={handleAddFormSubmit}
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                setPostModal(false);
                                Reset();
                              }}
                              className="btn btn-danger"
                            >
                              <i className="flaticon-delete-1"></i> Close
                            </button>
                          </div>
                        </form>
                      </Modal>
                    </div>
                    <Modal
                      className="modal fade "
                      show={editModal}
                      onHide={setEditModal}
                      backdrop="static"
                    >
                      <div className="" role="document">
                        <div className="">
                          <form>
                            <div className="modal-header">
                              <h4 className="modal-title fs-20">
                                Edit ExpenseDetails
                              </h4>
                              <button
                                type="button"
                                className="btn-close"
                                onClick={() => setEditModal(false)}
                                data-dismiss="modal"
                              ></button>
                            </div>
                            <div className="modal-body p-3">
                              <i
                                className="flaticon-cancel-12 close"
                                data-dismiss="modal"
                              ></i>
                              <div className="add-contact-box">
                                <div className="add-contact-box">
                                  <div className="add-contact-content">
                                    <div className="form-group">
                                      <div style={{ display: "flex", alignItems: "center", }}>
                                        <label htmlFor="">Category</label>
                                        <span className="text-danger star-error" style={{ marginTop: "-5px" }}>
                                          *
                                        </span>
                                      </div>
                                      <select

                                        name="Category"
                                        value={addFormData.Category || ""}
                                        onChange={handleAddFormChange}
                                      >
                                        <option value="" disabled>
                                          Select a category
                                        </option>
                                        {DropdownCategory?.map(
                                          (category, index) => (
                                            <option
                                              key={index}
                                              value={category.ExpenseCategoryID}
                                            >
                                              {category.Category}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </div>
                                  </div>

                                  <div className="add-contact-content">
                                    <div className="form-group">
                                      <div style={{ display: "flex", alignItems: "center", }}>
                                        <label htmlFor="">Expense Amount</label>
                                        <span className="text-danger star-error" style={{ marginTop: "-5px" }}>
                                          *
                                        </span>
                                      </div>
                                      <input
                                        type="number"
                                        // className="form-control"
                                        autoComplete="off"
                                        name="Amount"
                                        required="required"
                                        value={addFormData?.Amount}
                                        onChange={handleAddFormChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="add-contact-content">
                                    <div className="form-group">
                                      <div style={{ display: "flex", alignItems: "center", }}>
                                        <label htmlFor=""> Date</label>
                                        <span className="text-danger star-error" style={{ marginTop: "-5px" }}>
                                          *
                                        </span>
                                      </div>
                                      <input
                                        type="date"
                                        // className="form-control"
                                        autoComplete="off"
                                        name="Date"
                                        required="required"
                                        value={addFormData?.Date}
                                        onChange={handleAddFormChange}
                                      />

                                    </div>
                                    <div className="add-contact-content">
                                      <div className="form-group">
                                        <div style={{ display: "flex", alignItems: "center", }}>
                                          <label htmlFor=""> Next Renew Date</label>
                                          <span className="text-danger star-error" style={{ marginTop: "-5px" }}>
                                            *
                                          </span>
                                        </div>
                                        <input
                                          type="date"
                                          // className="form-control"
                                          autoComplete="off"
                                          name="Nextrenewedate"
                                          required="required"
                                          value={addFormData?.Nextrenewedate}
                                          onChange={handleAddFormChange}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                onClick={UpdateSlider}
                              >
                                Update
                              </button>
                              <button
                                type="button"
                                onClick={() => {
                                  setEditModal(false);
                                  Reset();
                                }}
                                className="btn btn-danger"
                              >
                                {" "}
                                <i className="flaticon-delete-1"></i> Close
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </Modal>
                    <div className="col-12 mt-2">
                      {loading ? (
                        <Loader />
                      ) : (
                        <DataTable
                          dense
                          data={decryptedExpenseList}
                          columns={columns}
                          selectableRowsHighlight
                          // pagination
                          persistTableHead={true}
                          noDataComponent={"There are no data to display"}
                          customStyles={customStyles}
                        />)}
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="Inactive">
                    <div className="row">
                      <div className="col-12 mt-2">
                        {loading ? (
                          <Loader />
                        ) : (
                          <DataTable
                            dense
                            data={decryptedExpenseList}
                            columns={columns1}
                            selectableRowsHighlight
                            highlightOnHover
                            pagination
                            fixedHeader
                            persistTableHead={true}
                            noDataComponent={"There are no data to display"}
                          />)}
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div >
      </Tab.Container >
    </>
  );
};
export default ExpenseDetails;
